import React, {Component} from "react";
import {Control, Field, Icon, Input} from "bloomer";
import Card from "../../../elements/Card";
import Button from "../../../elements/Button";
import {getDailyStockSentiment} from "../../../api/models/SentimentHistory";
import SendGAEvent, {GAEventActions, GAEventModels} from "../../../utils/SendGAEvent";
import InformationCard from "../../../elements/InformationCard";
import Spacer from "../../../elements/Spacer";
import ModelContentContainer from "../../../elements/ModelContentContainer";
import InputWarning from "../../../elements/InputWarning";
import SectionName from "../../../elements/SectionName";
import styled from "react-emotion";
import SocialSentimentResult from "./SocialSentimentResult";
import ErrorUtils from "../../../utils/ErrorUtils";
import {toast} from "react-toastify";
import {INVALID_FIELD_STYLE} from "../../../utils/Constants";

const InformationContainer = styled("div")`
  display: flex;
  flex-direction: column;
`;

interface ISocialSentimentModelState {
    loading: boolean;
    text: string;
    textEmpty: boolean;
    result: any;
    errorMessage: string;
}

class SocialSentimentModel extends Component<{}, ISocialSentimentModelState> {

    public constructor(props: {}) {
        super(props);

        this.state = {
            loading: false,
            text: "",
            textEmpty: false,
            result: [],
            errorMessage: ""
        };
    }

    public componentDidMount() {
        SendGAEvent(GAEventActions.VIEW_MODEL, GAEventModels.REDDIT_POSTS);
    }

    public handleTextChange = (e:any) => {
        const value = e.target.value;

        this.setState({
            text: value.toUpperCase(),
            textEmpty: !value.trim(),
            errorMessage: ""
        });
    };

    public handleTextInputKeyPress = (e:any) => {
        const code = e.which || e.keyCode;
        if (code === 13) {
            this.onSubmit(null);
        }
    };

    public onSubmit = async (e: any) => {
        if (e) {
            e.target.blur();
        }

        if (this.state.loading || !this.state.text.trim()) {
            if (!this.state.text.trim()) {
                this.setState({
                    textEmpty: true
                });
            }
            return;
        }

        this.setState({
            loading: true,
            result: [],
            errorMessage: ""
        });

        let errorOccurred = false;

        const response = await getDailyStockSentiment(this.state.text.trim()).catch((error) => {
            if (ErrorUtils.requestLimitExceeded(error.response)) {
                this.setState({
                    loading: false
                });
                toast.error(ErrorUtils.messageContent.REQUEST_LIMIT_EXCEEDED);
            } else {
                this.setState({
                    loading: false,
                    errorMessage: "Unable to get data."
                });
            }
            errorOccurred = true;
        });

        if (errorOccurred) {
            return;
        }

        if (response && response.data && response.data.daily_analysis) {
            this.setState({
                loading: false,
                result: response.data.daily_analysis.reverse()
            });
        } else {
            this.setState({
                loading: false,
                errorMessage: "Unable to get data."
            });
        }

        SendGAEvent(GAEventActions.CALL_MODEL, GAEventModels.REDDIT_POSTS);
    };

    public resetState = async (e: any) => {
        e.target.blur();

        if (this.state.loading) {
            return;
        }

        this.setState({
            loading: false,
            text: "",
            textEmpty: false,
            result: [],
            errorMessage: ""
        });
    };

    public render() {
        return <ModelContentContainer>
            <Card>
                <SectionName>Stock Ticker</SectionName>
                <Field>
                    <Control>
                        <Input
                            style={(this.state.textEmpty) ? INVALID_FIELD_STYLE : undefined}
                            type="text"
                            placeholder="Enter stock ticker here"
                            value={this.state.text}
                            onChange={this.handleTextChange}
                            onKeyPress={this.handleTextInputKeyPress}
                        />
                        <div>
                            {
                                this.state.textEmpty && <InputWarning>Please input stock ticker.</InputWarning>
                            }
                        </div>
                    </Control>
                </Field>
                <Spacer/>
                <div>
                    <Button onClick={this.onSubmit}>Submit</Button>
                    <Button onClick={this.resetState} style={{ marginLeft: "5px" }}>Reset</Button>
                </div>
                {
                    this.state.loading && <div>
                        <Spacer/>
                        <span>Loading...</span>
                        <Icon className="fas fa-spinner fa-spin" />
                    </div>
                }
                {
                    !this.state.loading && this.state.result.length > 0 ? <React.Fragment>
                        <Spacer/>
                        <SectionName>Output:</SectionName>
                        <InformationContainer>
                            {
                                this.state.result.map((sentiment: any) => {
                                    return <InformationCard key={sentiment.date}>
                                        <SocialSentimentResult
                                            data={sentiment}
                                        />
                                    </InformationCard>;
                                })
                            }
                        </InformationContainer>
                    </React.Fragment> : <></>
                }
                {
                    this.state.errorMessage && !this.state.loading && (<div>
                        <Spacer/>
                        <InformationCard>{this.state.errorMessage}</InformationCard>
                    </div>)
                }
            </Card>
        </ModelContentContainer>;
    }
}

export default SocialSentimentModel;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/SocialSentiment/SocialSentimentModel.tsx